<template>
    <div class="fold">
        <div class="fold__inner">
            <slot>
                <div class="fold__textbox">
                    <h1 class="fold__title">Who we are?</h1>

                    <div class="fold__description">
                        <p>Company /DIZ//VIZ/ is specialised in field of design and interior decoration and covers wide range of services – designing bussines and private spaces, design of product, 3d modeling and visualization of all kinds of objects. Every project is based on individual approach to the client and agreement about desires and possibilities of construction.</p>

                        <p><strong>We can provide whole process of making space from a sketch of an idea, design, visualization, furniture production and construction.</strong></p>
                    </div>
                </div>

                <figure class="fold__figure">
                    <picture>
                        <source srcset="../assets/img-01.jpg" media="(min-width: 768px)">
                        <img srcset="../assets/img-01--mobile.jpg" alt="" class="rspimg">
                    </picture>
                </figure>
            </slot>
        </div>
    </div>
</template>


<script>
import picturefill from 'picturefill'

export default {
    name: 'Fold',
    data() {
        return {
        }
    },
    mounted() {
        if(typeof picturefill === "function") {
            picturefill();
        }
    }
};
</script>